import React from 'react';

import { cn } from '~/lib/cn';

// tailwind-merge is not aware of the `tw-` prefix, so alignment is a prop instead of an
// overridable class to avoid two conflicting tw-items-* utilities on the same element
const alignClassNames = {
    end: 'tw-items-end',
    start: 'tw-items-start',
    stretch: 'tw-items-stretch'
};

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    align?: keyof typeof alignClassNames;
}

// Lays out its children as equally sized columns of a form row.
export const FormRow: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
    children,
    className,
    align = 'end',
    ...props
}) => {
    return (
        <div
            className={cn(
                'tw-relative tw-mb-3 tw-mt-0 tw-flex tw-gap-4',
                alignClassNames[align],
                // children share the row width evenly, so a field that is not full width on its
                // own cannot collapse to its content next to one that is
                '*:tw-mb-0 *:tw-min-w-0 *:tw-flex-1 *:tw-basis-0',
                className
            )}
            {...props}
        >
            {React.Children.map(children, (child) => child)}
        </div>
    );
};
